import { IV3D } from '@/Interfaces/v3d';
import { Mesh, Object3D, Vector3 } from 'three';
import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';


declare let v3d: IV3D;

const boxGeometry = new v3d.BoxGeometry(1, 1, 1);
const material = new v3d.MeshBasicMaterial({ color: 0x00ff00, transparent: true, opacity: 0.0 });

export class RaycastBox {
    model: Object3D;
    depth = 1;
    height = 1;
    width = 1;
    mesh: Mesh;
    constructor(width = 1, height = 1, depth = 1, parent: WardrobeObject) {
        // const startPoint = new v3d.Vector3(1,1,1);
        // const depth = 1;
        // const height = 1;
        // const width = 1;
        this.model = new v3d.Group();
        this.model.name = 'raycastBox';
        this.mesh = new v3d.Mesh(boxGeometry, material);
        this.mesh.name = 'raycastBoxGeometry';
        this.model.add(this.mesh);
        this.mesh.userData.parent = parent;
        // this.model.position.copy(startPoint);
        this.updateGeometry(width, height, depth);
    }

    // select(target: WardrobeObject) {
    //     this.model.position.set(...target.startPoint);
    //     // this.model.position.copy(target.model.position);
    //     if (target.width !== undefined && target.height !== undefined && target.depth  !== undefined)
    //         this.updateGeometry(target.width, target.height, target.depth);
    // }

    updateGeometry(width: number, height: number, depth: number) {
        this.mesh.scale.set(width, height, depth);
        this.mesh.position.set(width/2, height/2, depth/2);
    }

}
